import { render, staticRenderFns } from "./EditStaffDetails.vue?vue&type=template&id=4551b21e&"
import script from "./EditStaffDetails.vue?vue&type=script&lang=js&"
export * from "./EditStaffDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports